
  import { Component, Vue }                     from 'vue-property-decorator';
  import { Getter }                             from 'vuex-class';
  import   ChatView                             from '../chat/ChatView.vue';
  import   PresentationComponent                from '../../features/presentation/PresentationComponent.vue';
  import { ConfigService,
           ConfigChatroomThemeService }         from '../..';


  @Component({
    name: 'ChatroomView',
    components: {
      ChatView,
      PresentationComponent,
    }
  })
  export default class ChatroomView extends Vue {
    @Getter('isEmbeddedMode', { namespace: 'conversationSession' }) isEmbeddedMode!: boolean | undefined;
    @Getter('isRequestInProgress', { namespace: 'conversationSession' }) isRequestInProgress!: boolean;

    created() {
      const customCssFile: string | null = ConfigService.getCustomChatroomCSSFile();
      if (customCssFile) {
        let linkCssPreloadTag: HTMLLinkElement = document.createElement('link');
        linkCssPreloadTag.setAttribute('rel', 'preload');
        linkCssPreloadTag.setAttribute('href', customCssFile);
        linkCssPreloadTag.setAttribute('as', 'script');
        
        let linkCssTag: HTMLLinkElement = document.createElement('link');
        linkCssTag.setAttribute('href', customCssFile);
        linkCssTag.setAttribute('rel', 'stylesheet');

        let headElem: HTMLHeadElement = document.getElementsByTagName('head')[0];
        headElem.appendChild(linkCssPreloadTag);
        headElem.appendChild(linkCssTag);
      }
    }

    get rootContainerStyles() {
      return ConfigChatroomThemeService.getChatroomContainerStyles(this.$vuetify);
    }

    get loadingAnimationColor() {
      // the loader for initiliatization phase should have the main application accent colors 
      return ConfigChatroomThemeService.getLoadingAnimationColor(this.$vuetify);
    }

    get isExternalIntegration() {
      return ConfigService.isExternalIntegration();
    }
  }
